import { Routes } from '@angular/router';
import { provideModuleStore } from '@app/store/module';
import { provideFormOptionsStore } from '@app/store/form-options';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const modulesModalRoutes: Routes = [
    {
        path: 'modules/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideModuleStore(), ...provideFormOptionsStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'modules/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideModuleStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'modules/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideModuleStore(), ...provideFormOptionsStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
